interface ReverCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

const ReverCard: React.FC<ReverCardProps> = ({ children, ...props }) => {
  return (
    <div className="mt-6 w-[83%] max-w-[30rem] bg-white" {...props}>
      {children}
    </div>
  )
}

export default ReverCard
